/**
 * Load a script by URL and return a promise that resolves when the script is loaded
 */

export const loadScript = (url: string): Promise<void> => {
    return new Promise((resolve, reject) => {
        // Check if script is already loaded
        if (document.querySelector(`script[src="${url}"]`)) {
            resolve()
            return
        }

        const script = document.createElement('script')
        script.src = url
        script.async = true
        script.defer = true

        script.onload = () => resolve()
        script.onerror = () => reject(new Error(`Failed to load script: ${url}`))

        document.head.appendChild(script)
    })
}

export const loadStylesheet = (url: string): Promise<void> => {
    return new Promise((resolve, reject) => {
        const link = document.createElement('link')
        link.rel = 'stylesheet'
        link.type = 'text/css'
        link.href = url
        link.onload = () => resolve()
        link.onerror = () => reject()
        document.head.appendChild(link)
    })
}

export default function decodeHtmlEntitiesInHtml(html: string): string {
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')

    function decodeTextNodes(node: Node) {
        node.childNodes.forEach((child: ChildNode) => {
            if (child.nodeType === Node.TEXT_NODE) {
                if (child.nodeValue) {
                    const element = document.createElement('div')
                    element.innerHTML = child.nodeValue
                    child.nodeValue = element.textContent || ''
                }
            } else if (child.nodeType === Node.ELEMENT_NODE) {
                decodeTextNodes(child)
            }
        })
    }

    decodeTextNodes(doc.body)

    return doc.body.innerHTML
}
